__turbopack_context__.v({
  "BookCard": "-gbP6G_BookCard",
  "BookCardHeading": "-gbP6G_BookCardHeading",
  "book-card-description": "-gbP6G_book-card-description",
  "columns": "-gbP6G_columns",
  "row": "-gbP6G_row",
  "slider-details": "-gbP6G_slider-details",
  "slider-image": "-gbP6G_slider-image",
  "text-gradient-overlay": "-gbP6G_text-gradient-overlay",
});
